import { useState,useEffect } from "react";
import "./styles/Individuals.css";
import InternalError from "../generales/InternalError";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter,formatValue } from "../../utils/utils";
import LoadSimple from "../LoadSimple";
// Registrar componentes de Chart.js
//29
const Phones = ({handleShowPopup,server,languaje,mode,showHistoric}) => {
    
       
  const [workStations, setWorkStations] = useState([]);
    
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const newWorkStations = generateWorkStations(10); // Genera 5 estaciones de trabajo con valores aleatorios
  //     setWorkStations(newWorkStations);
  //   }, 2000); // Actualiza cada 2 segundos

  //   return () => clearInterval(interval); // Limpia el intervalo al desmontar el componente
  // }, []);

    useEffect(() => {
      const wsUrl = `${server.ws}/api/v1/cassia/dashboard/hosts_metrics_optimized`;

      const socket = new WebSocket(wsUrl);

      socket.onopen = () => {
        // mandar parámetros iniciales
        socket.send(JSON.stringify({
        dispId: "29",      // <- el device_id que ahora mandabas en el path
        page: 1,
        rows_per_page: 10,
        search: ""
        }));
      };

      socket.onmessage = (event) => {
          try {
            const payload = JSON.parse(event.data);
            setDataPrinter({
                data: payload.data.data,  // ojo: el WS envía en .data.data
                loading: false,
                error: {}
            });
          } catch (err) {
          console.error("❌ Error parseando WS:", err);
          }
      };

      socket.onerror = (err) => {
          console.error("❌ WS error:", err);
          setDataPrinter({ data: [], loading: false, error: { msg: "Error de conexión" } });
      };

      socket.onclose = (evt) => {};

      return () => {
        socket.close();
      };
    }, []);

  const [dataPrinter,setDataPrinter]=useState({data:{},loading:true,error:{}})

  const generateWorkStations = (count) => {
    return Array.from({ length: count }, (_, index) => {
      const metrics = Array.from({ length: 4 }, () => Math.floor(Math.random() * 100)); // Valores aleatorios para las métricas

      return (
        <div className="cont-globe">
        <div className="globe-info" key={index}>
          <div className="globe-title-info titleIndividuals">
            {`Printer ${index + 1}`}
          </div>
          <div className="globe-body-info" style={{ display: 'block', height: '90%', overflow: 'auto' }}>
            {metrics.map((metricValue, metricIndex) => (
              <div className="globe-title-info individualsInfo" key={metricIndex}>
                <div className="txt-info-individual">
                  {`Metrica ${metricIndex + 1}`}
                </div>
                <div className="value-info-individual" style={{color:((metricValue<30)?'var(--red-alert)':'var(--green)')}}>
                  {metricValue}
                </div>
              </div>
            ))}
          </div>
        </div>
        </div>
      );
    });
  };

return (
<>
    <div className="main-cont-graf-monitor">
        <div className="compact-graf-monitor">
          {

          (dataPrinter.loading)?<div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'100%',height:'100%'}}><LoadSimple></LoadSimple></div>:
          <section class='FlexContainerIndividuals'>
        {/* {workStations} */}
        {
          (dataPrinter.data.length==0 && dataPrinter.loading==false)?
          <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'100%',height:'100%',color:'var(--txt-color)'}}>Sin resultados</div>
        :
          dataPrinter.data.map((element,index)=>(
            <div className="cont-globe">
                                        <div className="globe-info">
                                            <div className="globe-title-info titleIndividuals  tooltip-container-individuals">
                                                {element.hostname}
                                                {/* {'Bosques_Demo_Printer_Kyocera_TASKALFA 3051ci_PISO5'} */}
                                            </div>
                                           
                                            <div className="globe-body-info" style={{display:'block',height:'90%',overflow:'auto'}}>
                                                <div className="globe-title-info individualsInfo" style={{width:'100%',height:'9%'}} >
                                                    <div className="txt-info-individual"  style={{width:'50%',left:'0%',textAlign:'center',display:'flex',justifyContent:'center',color:'var(--third-color)'}}>
                                                  {'IP:  '+element.ip}
                                                    </div>
                                                    <div className="txt-info-individual"  style={{width:'50%',left:'0%',textAlign:'center',display:'flex',justifyContent:'center',color:'var(--txt-color)'}}>
                                                  {'('+element.metrics.length+')  metricas capturadas'}
                                                    </div>
                                                </div>
                                                <div className="cont-list-metrics">
                                                {
                                                  (element.metrics.length==0)?
                                                  <div className="globe-title-info individualsInfo" >
                                                    <div className="txt-info-individual">
                                                        Sin metricas
                                                    </div>
                                                </div>:
                                                element.metrics.map((metric,indice)=>(
                                                  <div className="globe-title-info individualsInfo" >
                                                    <div className="txt-info-individual">
                                                        {metric.name}
                                                    </div>
                                                    <div className="value-info-individual" style={{color:((metric.danger==1)?'var(--red-alert)':'var(--green)')}}>
                                                    {(typeof metric.value === 'string')?metric.value:formatValue(metric.value)+" "+metric.units}
                                                    </div>
                                                </div>
                                                ))
                                                }
                                                </div>
                                                <div className="globe-title-info individualsInfo cont-btn-historical" style={{width:'100%',height:'10%'}} onClick={()=>{showHistoric(element)}}>
                                                <div className="txt-info-individual"  style={{width:'10%',color:'var(--main-color)',left:'0%',textAlign:'center',display:'flex',justifyContent:'center'}}>
                                                <img
                                                style={{width:'40%'}}
                                    src={
                                      "/iconos/grafic_line.png" 
                                    }
                                    name="provicionamiento"
                                  />
                                                    </div>
                                                    
                                                    <div className="txt-info-individual"  style={{width:'auto',color:'var(--main-color)',left:'0%',textAlign:'center',display:'flex',justifyContent:'center'}}>
                                                  {'Ver Detalles'}
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
          ))
        }
        
        {/* <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div> */}
    </section>
    }
        </div>
    </div>
</>
);
};

export default Phones;
